import React, { Component } from "react";
import { push } from "react-router-redux";
import classnames from "classnames";
import _ from "i18n";

import styles from "./CollaboratorSpace.local.scss";

import { TiWarningOutline } from "react-icons/ti";
import { FolderIcon, SettingIcon, SimpleArrowRight } from "../Common/Icons";

import {
  setFilterRoleCollaborators,
  setOrganizationListFilterConfigState,
  setFilterCollaborators
} from "actions";
import collaboratorApi from "../../services/CollaboratorServices";
import { Fragment } from "react";

class CollaboratorClientFolders extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      statistics: [],
      error: false,
      folderCount: 0
    };
  }

  componentDidMount() {
    const { year, synchro, spaceAs } = this.props;
    this.handleUpdateCollaboratorClientFolders(year, synchro, spaceAs);
  }

  handleUpdateCollaboratorClientFolders = (year, synchro, spaceAs) => {
    const { user, organization } = this.props;
    this.setState({ loading: true });
    collaboratorApi
      .getCollaboratorClientFolders(
        organization.uen,
        user.id,
        null,
        "",
        "COLLABORATOR_SPACE",
        year,
        synchro,
        spaceAs
      )
      .then(response => {
        let items = response.data.data;
        let count = 0;
        items.forEach(item => {
          count = count + item.total;
        });
        this.setState({
          statistics: items,
          folderCount: count,
          loading: false
        });
      })
      .catch(error => {
        this.setState({
          error: true,
          loading: false
        });
      });
  };

  getClientFoldersFetching() {
    let valuationsFetching = [];
    for (let i = 0; i < 3; i++) {
      valuationsFetching.push(
        <div key={i} className={styles.group_fetching}>
          <div className={styles.group_sub}>
            <div>
              <div className={styles.gradiant} />
              <div className={styles.gradiant} />
            </div>
            <div className={classnames(styles.icone, styles.gradiant)} />
          </div>
          <div className={styles.group_fetching_details}>
            <div>
              <div className={styles.gradiant} />
            </div>
            <div>
              <div className={styles.gradiant} />
              <div className={styles.gradiant} />
            </div>
            <div>
              <div className={styles.gradiant} />
              <div className={styles.gradiant} />
            </div>
          </div>
        </div>
      );
    }
    return valuationsFetching;
  }

  renderClientFoldersHeader = () => {
    let { folderCount } = this.state;
    return (
      <div className={styles.upper_section_header}>
        <div className={styles.label}>
          <div>
            {_("clientFolders")} ({folderCount})
          </div>
        </div>
        <div className={styles.explore_button}>
          <div onClick={() => this.handleRedirectClientsFolders()}>
            {_("explore")}
          </div>
        </div>
      </div>
    );
  };

  renderClientFoldersData = () => {
    let { statistics } = this.state;
    let { synchro } = this.props;
    return statistics.map((item, k) => {
      // eslint-disable-next-line array-callback-return
      let subTotals = Object.keys(item.subTotals).map(key => {
        if (item.subTotals[key] > 0) {
          return (
            <div
              key={`${item.id}-${key}`}
              className={styles.details}
              onClick={() => this.handleRedirectClientsFolders(key, item.code)}
            >
              <span>{_(key)}</span>
              <span>
                <b>{item.subTotals[key]}</b>
              </span>
              <SimpleArrowRight />
            </div>
          );
        }
      });
      return (
        <div key={k} className={styles.group}>
          <div
            className={styles.group_total}
            style={{
              borderLeft: `3px solid ${
                item.code === "CONFIGURED"
                  ? "#06D9B1"
                  : item.code === "NO_ANNEXES"
                    ? "#FFB340"
                    : "#F9626D"
              }
            `
            }}
          >
            <div className={styles.group_sub}>
              <h5>{_(item.label)}</h5>
              <h2>
                {_("total")} : {item.total}
              </h2>
            </div>
            <div
              className={styles.folder_icon}
              onClick={() =>
                this.handleRedirectClientsConfigurationFolders(item.code)
              }
            >
              <FolderIcon
                fill={
                  item.code === "CONFIGURED"
                    ? "#06D9B1"
                    : item.code === "NO_ANNEXES"
                      ? "#FFB340"
                      : "#F9626D"
                }
              />
            </div>
          </div>
          <div className={styles.group_details}>
            {item.total > 0 && synchro ? (
              <Fragment>
                <div className={styles.as}>
                  <b>{_("as")} :</b>
                </div>
                {subTotals}
              </Fragment>
            ) : (
              ""
            )}
          </div>
        </div>
      );
    });
  };

  renderClientFoldersFooter = () => {
    return (
      <div className={styles.upper_section_footer}>
        <div
          className={styles.button}
          onClick={() => this.handleRedirectClientsFolders()}
        >
          <SettingIcon fill="#6D7F92" size={12} />
          <span>{_("traitMyFolders")}</span>
        </div>
      </div>
    );
  };

  handleRedirectClientsFolders = (role, configState) => {
    const { dispatch } = this.props;
    dispatch(
      setFilterRoleCollaborators(
        role === "gd"
          ? "GD"
          : role === "ge"
            ? "GE"
            : role === "es"
              ? "SE"
              : role === "super"
                ? "SUP"
                : role === "gd"
                  ? "GD"
                  : role === "scan"
                    ? "SCAN_OP"
                    : ""
      )
    );
    dispatch(
      setOrganizationListFilterConfigState(configState ? configState : "")
    );
    this.handleRedirectClients();
  };

  handleRedirectClientsConfigurationFolders = configState => {
    const { dispatch } = this.props;
    dispatch(setFilterRoleCollaborators(""));
    dispatch(setOrganizationListFilterConfigState(configState));
    this.handleRedirectClients();
  };

  handleRedirectClients = () => {
    const { synchro, dispatch, user, year } = this.props;
    if (synchro) {
      dispatch(push(`/folders?collaboratorId=${user.id}&year=${year}`));
      dispatch(
        setFilterCollaborators([
          { value: user.id, label: user.name, color: "#000000" }
        ])
      );
    } else {
      dispatch(push(`/folders?year=${year}`));
    }
  };

  render() {
    let { loading, error } = this.state;
    let { synchro } = this.props;
    return (
      <div className={styles.upper_section}>
        {this.renderClientFoldersHeader()}
        {loading && (
          <div className={styles.fetching_folders}>
            {this.getClientFoldersFetching()}
          </div>
        )}
        {error ? (
          <div className={styles.error_frame}>
            <TiWarningOutline />
          </div>
        ) : (
          !loading && (
            <div>
              {this.renderClientFoldersData()}
              {synchro ? this.renderClientFoldersFooter() : ""}
            </div>
          )
        )}
      </div>
    );
  }
}

export default CollaboratorClientFolders;



// WEBPACK FOOTER //
// ./src/components/CollaboratorSpace/CollaboratorClientFolders.js